//! PLEASE keep this list in alphabetical order for a better readability
export enum CAMPAIGNS {
    /**
     * @value You are about to %CHANGE% the campaign baseline date.
     */
    ABOUT_TO_CHANGE_BASELINE_DATE = 'CAMPAIGNS.ABOUT_TO_CHANGE_BASELINE_DATE',
    /**
     * @value Archive campaign?
     */
    ARCHIVE_CAMPAIGN = 'CAMPAIGNS.ARCHIVE_CAMPAIGN',
    /**
     * @value Adding or removing administrators from this page impacts both broadcasts and campaigns.
     * @description This message is here to let the user know the impact changing the administrator roles will have on broadcasts and campaigns
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    BANNER_ROLES_ADMINS = 'CAMPAIGNS.BANNER_ROLES_ADMINS',
    /**
     * @value The baseline date is used to define the sending date of a broadcast
     * @description Description of a campaign's baseline date
     *
     * "broadcast" is a product name, it should not be translated
     */
    BASELINE_DESCRIPTION = 'CAMPAIGNS.BASELINE_DESCRIPTION',
    /**
     * @value All broadcasts scheduled based on this baseline date will be updated and rescheduled based on the new date.
     * @description "broadcast" is a product name here, it should not be translated
     */
    BROADCASTS_BASELINE_DATE_WILL_UPDATE = 'CAMPAIGNS.BROADCASTS_BASELINE_DATE_WILL_UPDATE',
    /**
     * @value Any broadcast scheduled in the past following the change will go back to draft.
     * @description "broadcast" is a product name here, it should not be translated
     */
    BROADCASTS_WILL_GO_TO_DRAFT = 'CAMPAIGNS.BROADCASTS_WILL_GO_TO_DRAFT',
    /**
     * @value Campaign
     * @description A campaign is used to communicate with employees by sending them a set of notifications.
     */
    CAMPAIGN = 'CAMPAIGNS.CAMPAIGN',
    /**
     * @value Campaigns and Broadcasts
     * @description Name of the features, PLEASE DON'T TRANSLATE "CAMPAIGNS" and "BROADCASTS"
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    CAMPAIGNS_BROADCASTS = 'CAMPAIGNS.CAMPAIGNS_BROADCASTS',
    /**
     * @value Campaign archived
     */
    CAMPAIGN_ARCHIVED = 'CAMPAIGNS.CAMPAIGN_ARCHIVED',
    /**
     * @value Campaign name
     * @description  Label of the field for campaign creation/edition
     */
    CAMPAIGN_NAME = 'CAMPAIGNS.CAMPAIGN_NAME',
    /**
     * @value Campaign saved
     * @description Text displayed in the notification when the campaigns has been created
     */
    CAMPAIGN_SAVED = 'CAMPAIGNS.CAMPAIGN_SAVED',
    /**
     * @value Campaign unarchived
     */
    CAMPAIGN_UNARCHIVED = 'CAMPAIGNS.CAMPAIGN_UNARCHIVED',
    /**
     * @value Campaign unavailable
     * @description Used as a notification message to let the user know that the requested campaign is not available.
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     */
    CAMPAIGN_UNAVAILABLE = 'CAMPAIGNS.CAMPAIGN_UNAVAILABLE',
    /**
     * @value All related broadcasts will remain available in your broadcasts list.
     * @description "broadcasts" is a product name here, it shouldn't be translated
     */
    CONFIRM_ARCHIVE_DESCRIPTION = 'CAMPAIGNS.CONFIRM_ARCHIVE_DESCRIPTION',
    /**
     * @value Describe your campaign
     */
    DESCRIBE_YOUR_CAMPAIGN = 'CAMPAIGNS.DESCRIBE_YOUR_CAMPAIGN',
    /**
     * @value Campaign description
     */
    DESCRIPTION = 'CAMPAIGNS.DESCRIPTION',
    /**
     * @value There are no campaigns
     * @description Text to be displayed when the campaign list is empty
     */
    EMPTY_STATE_TITLE = 'CAMPAIGNS.EMPTY_STATE_TITLE',
    /**
     * @value Name your campaign
     * @description The placeholder of the title field
     */
    NAME_YOUR_CAMPAIGN = 'CAMPAIGNS.NAME_YOUR_CAMPAIGN',
    /**
     * @value Name your campaign baseline date
     * @description Placeholder for the baseline date title field
     */
    NAME_YOUR_CAMPAIGN_BASELINE_DATE = 'CAMPAIGNS.NAME_YOUR_CAMPAIGN_BASELINE_DATE',
    /**
     * @value New campaign
     * @description Button to create a new campaign
     */
    NEW_CAMPAIGN = 'CAMPAIGNS.NEW_CAMPAIGN',
    /**
     * @value No baseline has been set
     * @description Message displayed on a campaign when no baseline date has been set yet.
     */
    NO_BASELINE_SET = 'CAMPAIGNS.NO_BASELINE_SET',
    /**
     * @value {"one":"%NUMBER% broadcast","other":"%NUMBER% broadcasts"}
     * @description "broadcast"/"broadcasts" are product names, they should not be translated
     */
    NUMBER_BROADCAST = 'CAMPAIGNS.NUMBER_BROADCAST',
    /**
     * @value Progression
     */
    PROGRESSION = 'CAMPAIGNS.PROGRESSION',
    /**
     * @value All broadcasts scheduled based on this baseline date will be sent back to draft. You will need to reschedule them.
     * @description "broadcast" is a product name here, it should not be translated
     */
    RESCHEDULE_BROADCASTS_WARNING = 'CAMPAIGNS.RESCHEDULE_BROADCASTS_WARNING',
    /**
     * @value Campaigns settings
     * @description A campaign is a set of broadcasts about one specific topic.
     */
    SETTINGS = 'CAMPAIGNS.SETTINGS',
    /**
     * @value Show archived campaigns
     */
    SHOW_ARCHIVED_CAMPAIGNS = 'CAMPAIGNS.SHOW_ARCHIVED_CAMPAIGNS',
    /**
     * @value All campaigns
     * @description Title of a button in a menu. Clicking it will display a page with all campaigns.
     */
    SIDE_NAV_TITLE = 'CAMPAIGNS.SIDE_NAV_TITLE',
    /**
     * @value Campaigns
     * @description Title of the "campaigns" section and page
     */
    TITLE = 'CAMPAIGNS.TITLE',
    /**
     * @value Update related broadcasts
     * @description "broadcasts" is a product name here, it should not be translated
     */
    UPDATE_RELATED = 'CAMPAIGNS.UPDATE_RELATED',
}
